import {useAlternativeRelatedModelTest} from './constants/signalmanConstants';

export function fireAlternativeRelatedItemsModelTestAnalyticsEvent() {
  window.dataLayer.push({
    ab_test_group: useAlternativeRelatedModelTest,
    ab_test_location: 'pdp catalog',
    ab_test_name: '2025 09 04 similar products model improvements',
    event: 'ab_test_group'
  });
}

export function getIsAlternativeRelatedItemsModelTestEnabled() {
  return useAlternativeRelatedModelTest === 'test';
}

export function getAlternativeRelatedItemsModelLabel() {
  return useAlternativeRelatedModelTest === 'test'
    ? 'alternative_related_items'
    : 'default_related_items';
}
